import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../helper/commonFunctions";
import { ApiGet } from "../../helper/axiosFunctions";
import { commonToast } from "../../helper/Toast";

export default function SubjectDetailCard({ data }) {
    const { t } = useTranslation();
    const [creatorData, setCreatorData] = useState({});
    const [loading, setLoading] = useState(false);

    const getCreatorData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await ApiGet(`/users/${data.authorId}`);
            setCreatorData(response?.data);
        } catch (error) {
            commonToast(error?.data?.error || error?.message, "error");
        } finally {
            setLoading(false);
        }
    }, [data.authorId])

    useEffect(() => {
        getCreatorData();
    }, [getCreatorData]);

    const LoadingSkeleton = () => (
        <div className="font-medium text-gray-900 bg-slate-200 animate-pulse h-5 rounded"></div>
    );

    const DetailRow = ({ label, value, show = true }) => {
        if (!show) return null;
        return (
            <>
                <div className="text-gray-600 text-sm">{label}:</div>
                {loading ? (
                    <LoadingSkeleton />
                ) : (
                    <div className="font-medium text-gray-900">
                        {value}
                    </div>
                )}
            </>
        );
    };

    return (
        <div className="bg-white p-6 rounded-2xl border max-w-lg">
            <div className="space-y-4">
                <div className="grid grid-cols-2 gap-4 capitalize">
                    <DetailRow label="Deck Name" value={data?.deckName} />
                    <DetailRow label="Status" value={data?.status} show={data?.status} />
                    <DetailRow
                        label="Author Name"
                        value={`${creatorData?.firstName} ${creatorData?.lastName}`}
                    />
                    <DetailRow
                        label="Created By"
                        value={`${creatorData?.firstName} ${creatorData?.lastName}`}
                    />
                    <DetailRow label="Language" value={data?.language} show={data?.language} />
                    <DetailRow
                        label="Countries"
                        value={data?.countries?.join(", ")}
                        show={data?.countries?.length > 0}
                    />
                    <DetailRow
                        label="Creation Date"
                        value={formatDate(data?.creationDate)}
                    />

                    <DetailRow
                        label={t("gradeLabel")}
                        value={
                            data?.schoolGrades && data.schoolGrades.length > 0 && data.schoolGrades.some(grade => grade && grade.trim() !== "")
                                ? data.schoolGrades.filter(grade => grade && grade.trim() !== "").join(", ")
                                : "N/A"
                        }
                    />
                </div>
                {data?.longDescription && (
                    <div className="text-gray-700 text-sm leading-relaxed border-t pt-4">
                        {loading ? (
                            <>
                                <LoadingSkeleton />
                                <LoadingSkeleton className="mt-2" />
                            </>
                        ) : (
                            <div className="font-medium text-gray-700">
                                {data.longDescription}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
